"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextPaneHeaderSep = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("../../styles/context");
const ContextPaneHeaderSep = () => {
    const styles = (0, context_1.useStyles)();
    return (React.createElement("div", { style: { background: styles.g(0, 0.05), width: '100%', height: 8, marginBottom: -8 } },
        React.createElement("div", { style: {
                background: styles.light ? styles.bg + '' : styles.g(0.94),
                borderRadius: '8px 8px 0 0',
                width: '100%',
                height: '8px',
            } })));
};
exports.ContextPaneHeaderSep = ContextPaneHeaderSep;
